import {
  all, call, put, takeLatest,
} from '@redux-saga/core/effects';
import CashbackActionType from 'actions/cashBack/cashBackActionType';
import {
  changeLoadingState, setSuccessMessage, setErrorMessage, changeEndedStatus,
} from 'app/settings/slices';
import NetworkService from 'services/networkService';
import {
  saveCashBack,
} from 'actions/cashBack/cashBackActionCreator';
import { i18n } from 'services';
import { AppConstants } from 'constants/index';
import { isJSON } from 'utils/utils';
import { getError, getMessage } from 'utils/helpers';

function* createCashBack({ payload }) {
  try {
    const { name } = payload.data;
    const { DataCollector, Cashback } = AppConstants.api;
    yield put(changeLoadingState(true));
    yield call(NetworkService.makeAPIPostRequest, [DataCollector, Cashback], payload);
    yield put(setSuccessMessage(getMessage(i18n.t('lCashback'), i18n.t('notification:slCreated'), name)));
    yield put(changeLoadingState(false));
    yield put(changeEndedStatus(true));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* getCashBack({ payload }) {
  try {
    const { id, params } = payload;
    const { DataCollector, Cashback } = AppConstants.api;
    yield put(changeLoadingState(true));
    const { data } = yield call(NetworkService.makeAPIGetRequest, [DataCollector, Cashback, id], { params });
    yield put(saveCashBack(data));
    yield put(changeLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err, true);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* editCashBack({ payload }) {
  try {
    const { name } = payload.data;
    yield put(changeLoadingState(true));
    const { DataCollector, Cashback } = AppConstants.api;
    yield call(NetworkService.makeAPIPutRequest, [DataCollector, Cashback], payload);
    yield put(changeEndedStatus(true));
    yield put(setSuccessMessage(getMessage(i18n.t('lCashback'), i18n.t('notification:slUpdated'), name)));
    yield put(changeLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

export default function* cashBackSaga() {
  yield all([
    takeLatest(CashbackActionType.CREATE_CASH_BACK, createCashBack),
    takeLatest(CashbackActionType.GET_CASH_BACK, getCashBack),
    takeLatest(CashbackActionType.EDIT_CASH_BACK, editCashBack),
  ]);
}
